import { render, staticRenderFns } from "./CriterionEditor.vue?vue&type=template&id=1323b3a0&scoped=true"
import script from "./CriterionEditor.vue?vue&type=script&lang=ts"
export * from "./CriterionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323b3a0",
  null
  
)

export default component.exports